export default __webpack_public_path__ + "static/media/rewind-button-light.c4da34c5.svg";